import { Checkbox, CircularProgress, Grid2 as Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

export const SelectionStatus = {
    SELECTED: 'selected',
    INDETERMINATE: 'indeterminate',
    NOT_SELECTED: false,
};

const styles = () => ({
    headerCell: {
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: COLORS.LT_MIDNIGHTBG1,
        flexShrink: 1,
        '&:first-child': {
            paddingLeft: '24px',
            borderRadius: '8px 0 0 8px',
        },
        '&:last-child': {
            paddingRight: '24px',
            justifyContent: 'flex-end',
            borderRadius: '0 8px 8px 0',
        },
    },
});

function ListViewHeaderCell({ classes, status, onClick, ...rest }) {
    const handleClick = (e) => onClick(e.target.checked);
    return (
        <Grid className={classes.headerCell} {...rest}>
            {status === 'loading' ? (
                <CircularProgress size={20} sx={{ mx: 1 }} />
            ) : (
                <Checkbox
                    sx={{ p: 1 }}
                    checked={status === SelectionStatus.SELECTED || status === true}
                    indeterminate={status === SelectionStatus.INDETERMINATE}
                    onClick={handleClick}
                />
            )}
        </Grid>
    );
}

export default withStyles(styles)(ListViewHeaderCell);
